/**
 * * Запрос метода GetPerformersTask
 */
export default class GetPerformersTaskRequestModel {
  /**
   * * Id задачи
   */
  TaskId!: number;
  /**
	 * * Фильр который при true показывает только исполнителей у которых нет данной задачи в очередности 
            при false показывает все исполнителей
	 */
  ShowUsersWhoNotHaveTaskInQueue: boolean = false;
  /**
   * * Показывать только тех пользователей к которым есть доступ на добавление в очередность
   */
  ShowUsersWithAccessToQueue: boolean = false;
  constructor(obj?: Partial<GetPerformersTaskRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
